import Column from 'components/atoms/column'
import Row from 'components/atoms/row'
import Text from 'components/atoms/text'
import { classNameBuilder } from 'helpers/class-name-builder'
import { uniqueId } from 'lodash'
import React from 'react'

export type Color = 'default' | 'white'

export interface CheckboxProps {
  id?: string
  name?: string
  className?: string
  label?: string
  checked?: boolean
  disabled?: boolean
  onChange?: (
    value: boolean,
    event: React.ChangeEvent<HTMLInputElement>
  ) => void
  onBlur?: (event: React.FocusEvent<HTMLInputElement, Element>) => void
  onFocus?: (event: React.FocusEvent<HTMLInputElement, Element>) => void
  required?: boolean
  error?: string
  color?: Color
  value?: string
}

const Checkbox: React.FC<CheckboxProps> = ({
  name = uniqueId('checkbox-'),
  className,
  label,
  onChange,
  error,
  color = 'default',
  disabled,
  ...inputProps
}) => {
  return (
    <Column className={className ?? 'text-sm font-normal text-white'}>
      <Row className={classNameBuilder('items-center space-x-sm')}>
        <input
          name={name}
          type="checkbox"
          onChange={(event) => onChange?.(event.target.checked, event)}
          className={classNameBuilder(
            'h-md w-md cursor-pointer rounded disabled:cursor-not-allowed disabled:border disabled:border-dashed',
            `${inputColorClassMap[color]}`
          )}
          disabled={disabled}
          {...inputProps}
        />
        <label
          htmlFor={name}
          className={classNameBuilder(
            'select-none',
            disabled ? 'cursor-not-allowed text-opacity-60' : 'cursor-pointer'
          )}
        >
          {label}
        </label>
      </Row>
      <Text className="h-0 text-xs text-red-400">{error}</Text>
    </Column>
  )
}

export default Checkbox

const inputColorClassMap: Record<Color, string> = {
  default: 'text-indigo-500 border-gray-300 focus:ring-indigo-700',
  white: `text-white text-opacity-10 bg-white bg-opacity-10 focus:ring-indigo-300 border-0`,
}
